import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@c/views/Home.vue'
import store from '@/store/index.js'
import NotFound from '@c/views/NotFound.vue'
import VacancyDescription from '@/components/VacancyDescription.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/components/views/About.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '@/components/views/Contact.vue'),
  },
  {
    path: '/vacancies',
    name: 'vacancies',
    component: () => import(/* webpackChunkName: "vacancies" */ '@/components/views/Vacancies.vue'),
  },
  {
    path: '/vacancies/new',
    name: 'newvacancy',
    component: () =>
      import(/* webpackChunkName: "vacancy-form" */ '@/components/views/VacancyForm.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/vacancies/:id',
    component: () =>
      import(/* webpackChunkName: "vacancy-details" */ '@/components/views/VacancyDetails.vue'),
    beforeEnter: (_to, _from, next) => {
      store.dispatch('vacancies/maybeFetchVacancies')
      next()
    },
    children: [
      {
        path: '',
        name: 'vacancydetails',
        component: VacancyDescription,
      },
      {
        path: 'reactions',
        name: 'reactions',
        component: () => import('@/components/VacancyReactions.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/vacancies/:id/edit',
    name: 'editvacancy',
    component: () =>
      import(/* webpackChunkName: "vacancy-form" */ '@/components/views/VacancyForm.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/components/views/Login.vue'),
  },
  {
    path: '/*',
    name: '404',
    component: NotFound,
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    // let user
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      .then(() => {
        // if (data) console.log('currentAuthenticatedUser in router', data)
        // else console.log('no currentAuthenticatedUser in router')
        next()
      })
      .catch(() => {
        next({ path: '/login' })
      })
  } else next()
})

export default router
